import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getAccess } from '~/modules/access';
import type { RootState } from '~/state/reducers';

/** The signed-in user: session profile fields plus the access flags derived from the token. */
export interface UserState {
  isAdmin: boolean;
  isStaff: boolean;
  isUser: boolean;
  isGlobalAdmin?: boolean;
  isGlobalUser?: boolean;
  isSystemAdmin?: boolean;
  isSuperAdmin?: boolean;
  isSuperUser?: boolean;
  canLogin?: boolean;
  role?: string;
  id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  imageUrl?: string;
  [key: string]: unknown;
}

const initialState: UserState = {
  isAdmin: false,
  isStaff: false,
  isUser: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserState: (state, action: PayloadAction<Partial<UserState> | undefined>) => {
      const access = getAccess();
      const user = { ...action.payload, ...access };

      return { ...state, ...user };
    },
    resetUserState: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserState, resetUserState } = userSlice.actions;

export const getUserState = (state: RootState) => state.user;

export default userSlice.reducer;
